export default __webpack_public_path__ + "static/media/default.fead311e.png";